import React from 'react';
import PropTypes from 'prop-types';

import SearchSubscriptionFeatureUpsell from './SearchSubscriptionFeatureUpsell';
import withModal from '../../../../../../../components/global/modal/withModal';
import DismissButton from '../../../../../../../components/global/DismissButton';

export const SEARCH_SUBSCRIPTION_FEATURE_UPSELL_MODAL =
  'modal/SEARCH_SUBSCRIPTION_FEATURE_UPSELL_MODAL';

const propTypes = {
  onClose: PropTypes.func,
  onRequestClose: PropTypes.func,
  actionProps: PropTypes.shape({
    featureId: PropTypes.string,
    onCheckoutSuccess: PropTypes.func,
    title: PropTypes.node,
    subtitle: PropTypes.node,
    illustration: PropTypes.node,
  }),
};

const SearchSubscriptionFeatureUpsellModal = ({
  onRequestClose,
  onClose,
  actionProps: {
    featureId,
    onCheckoutSuccess,
    title,
    subtitle,
    illustration,
  } = {},
  ...props
}) => {
  return (
    <>
      <DismissButton
        onClick={() => {
          onClose?.();
          onRequestClose?.();
        }}
        className="photo-search-modal-dismiss"
      />
      <SearchSubscriptionFeatureUpsell
        {...props}
        featureId={featureId}
        onCheckoutSuccess={onCheckoutSuccess}
        onClose={() => {
          onClose?.();
          onRequestClose?.();
        }}
        title={title}
        subtitle={subtitle}
        illustration={illustration}
      />
    </>
  );
};

SearchSubscriptionFeatureUpsellModal.propTypes = propTypes;

export default withModal(SearchSubscriptionFeatureUpsellModal, {
  name: SEARCH_SUBSCRIPTION_FEATURE_UPSELL_MODAL,
  className:
    'photo-search-upsell-modal search-subscription-feature-upsell-modal',
  overlayClassName: 'search-subscription-purchase-modal-overlay',
  size: 'md',
  dismissible: false,
});
